import {CommonMessages} from '../common.messages';

export const AssignSupervisedRightsMessages = {
    AssignRightsFailed: {
        key: 'AssignRightsFailed',
        message: 'Assign supervision to client <<name>> failed.'
    },
    AssignRightsSucceed: {
        key: 'AssignRightsSucceed',
        message: 'Supervision to client <<name>> are successfully assigned.'
    },
    ...CommonMessages
};
